import React, { useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleWorkFlowDetails = () => {
  const { workflowId } = useParams(); // Get workflow ID from the URL parameters
  const decodedId = workflowId ? atob(workflowId) : workflowId;
  const id = decodedId.replace(/\D/g, ''); // Sanitize ID to ensure it's a number
  const [showDelete, setShowDelete] = useState(false);
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);

  const url = id ? `${API_DOMAIN}${API_ROUTES.workflow}${id}/` : null;
  const { data: workflowDetails, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!workflowDetails) return [];
    // Extract columns dynamically from the data (if applicable)
    const excludedColumns = ['id', 'updated_at', 'created_at'];

    return Object.keys(workflowDetails)
      .filter(column => !excludedColumns.includes(column))
      .map(column => ({
        label: column.charAt(0).toUpperCase() + column.slice(1),
        field: column,
      }));
  }, [workflowDetails]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.workflow}${id}/`, { headers });
      showToast('Workflow deleted successfully', 'success');
      navigate('/workflow/list');
    } catch (error) {
      console.error('Error deleting workflow:', error);
      showToast('Failed to delete workflow', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={workflowDetails}
        columns={columns}
        loading={loading}
        entityName="Workflow"
        listPath="/workflow/list"
        editPath={`/workflow/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Workflow"
        message="Are you sure you want to delete this workflow?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleWorkFlowDetails;
